export const COMPARE_PLANS_QK = 'comparePlans';
export const COMPARE_PLANS_DISPLAY_ORDER_QK = 'comparePlansDisplayOrder';

export const queryKeys = {
  comparePlans: (clientId: string, planIds: string[]) => [COMPARE_PLANS_QK, clientId, planIds],
  comparePlansAll: (clientId: string) => [COMPARE_PLANS_QK, clientId],
  comparePlansDisplayOrder: (clientId: string) => [COMPARE_PLANS_DISPLAY_ORDER_QK, clientId],
};
